import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer, CardContent, Button, CircularProgress, Box, Table, TableHead, TableCell, TableRow, TableBody,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import SearchIcon from "@mui/icons-material/Search";
import MenuItem from "@mui/material/MenuItem";
import {useLazyGetAccountsQuery, useLazyGetGroupsByPatternQuery} from "../store/group/groupApi";
import copyObject from "../utils/copyObject";

export default function StudentsAccountsListPage() {
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [searchGroupsByPattern] = useLazyGetGroupsByPatternQuery();
    const [groups, setGroups] = useState([]);
    const [pattern, setPattern] = useState('');
    const [accounts, setAccounts] = useState([]);
    const [getAccounts] = useLazyGetAccountsQuery();

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const handleSave = async () => {
        setIsSaving(true);

        // await createAttestation({courseId: id, startDate, endDate}).unwrap().then((fulfilled) => {
        //     if (fulfilled?.success) {
        //         navigate('/facultyattestations');
        //     } else {
        //         fulfilled.errors.map((item) => {
        //             alert(item);
        //             return 1;
        //         });
        //
        //         setIsSaving(false);
        //     }
        // });
    };
    
    async function searchGroups() {
        setIsLoading(true);

        await searchGroupsByPattern({data: {pattern}}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setGroups(copyObject(fulfilled.data))
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsLoading(false);
        }).catch(() => {
            alert('Ошибка');
            setIsLoading(false);
        });
    }
    
    async function loadAccounts(group) {
        setIsLoading(true);
        await getAccounts({data: {groupId: group.groupId}}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setAccounts(copyObject(fulfilled.data))
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }
            
            setIsLoading(false);
        }).catch(() => {
            alert('Ошибка');
            setIsLoading(false);
        })
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Учетные записи`} />

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            Учетные записи студентов
                        </Typography>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack spacing={2}>
                                <Stack spacing={1} direction={'row'}>
                                    <TextField
                                        size={'small'}
                                        label="Поиск группы"
                                        variant="outlined"
                                        value={pattern}
                                        onChange={(event) => setPattern(event.target.value)}
                                        fullWidth
                                    />
                                    
                                    <Button startIcon={isLoading ? <CircularProgress size={15}/> : <SearchIcon/>} 
                                            size={'small'}
                                            disabled={isLoading}
                                            onClick={() => {searchGroups()}}>Поиск</Button>
                                </Stack>
                                <TextField
                                    size={'small'}
                                    label={'Выберите группу'}
                                    fullWidth
                                    onChange={(event) => {loadAccounts(event.target.value)}}
                                    select>
                                    {groups?.sort((l,r) => l.groupName > r.groupName ? 1 : -1).map((item) => {
                                        return <MenuItem key={item.groupName} value={item}>{item.groupName}</MenuItem>
                                    })}
                                </TextField>
                            </Stack>
                        </CardContent>
                    </Card>

                    {isLoading
                    ? <CircularProgress />
                    : <Card>
                            <Table size={'small'}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ФИО</TableCell>
                                        <TableCell>Логин</TableCell>
                                        <TableCell>Пароль</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {accounts.sort((l,r) => l.fullName > r.fullName ? 1 : -1).map((item) => {
                                        return <TableRow>
                                            <TableCell>{item.fullName}</TableCell>
                                            <TableCell>{item.username}</TableCell>
                                            <TableCell>{item.password}</TableCell>
                                        </TableRow>
                                    })}
                                </TableBody>
                            </Table>
                        </Card>}
                    
                    <br />
                </Stack>
            </Container>
        </GeneralLayout>
    );
}
